<template>
  <loader :task="task" />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ProfileType } from '@/iam/external/types';
import Loader from '@/components/loading/AsyncLinearProgress.vue';
import repository from './profile-type-repository';

interface Data {
  task: Promise<ProfileType[]>|null,
}

export default defineComponent({
  emits: ['loaded'],
  components: {
    Loader,
  },
  data(): Data {
    return {
      task: null,
    };
  },
  methods: {
    load(): void {
      this.task = repository.findAll();
      this.task.then((profileTypes: ProfileType[]) => {
        this.$emit('loaded', profileTypes);
      });
    },
  },
  created(): void {
    this.load();
  },
});
</script>
